// Barra de edad y colágeno (k2o): se puede arrastrar y arranca sola al aparecer.
(function () {
  function iniciar() {
    document.querySelectorAll('[data-pc-edad]').forEach(function (caja) {
      var zona = caja.querySelector('.pc-k-edad-zona');
      var rango = caja.querySelector('[data-pc-edad-rango]');
      var pastilla = caja.querySelector('[data-pc-edad-pastilla]');
      if (!zona || !rango || !pastilla) return;

      var min = parseFloat(caja.getAttribute('data-min'));
      var max = parseFloat(caja.getAttribute('data-max'));
      var meta = parseFloat(caja.getAttribute('data-meta'));
      var porAnio = parseFloat(caja.getAttribute('data-pct')) || 1;
      var plantilla = caja.getAttribute('data-texto') || '{edad} años: -{pct}% de colágeno';

      function pintar(edad) {
        var perdida = Math.max(0, Math.round((edad - min) * porAnio));
        pastilla.textContent = perdida === 0
          ? edad + ' años: colágeno al máximo'
          : plantilla.replace('{edad}', edad).replace('{pct}', perdida);
        var frac = (edad - min) / (max - min);
        pastilla.style.left = 'calc(' + frac + ' * (100% - 24px) + 12px)';
      }

      rango.addEventListener('input', function () { caja.setAttribute('data-tocado', '1'); pintar(Math.round(parseFloat(rango.value))); });
      pintar(meta);

      var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducido || !('IntersectionObserver' in window)) return;

      var corrio = false;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting || corrio) return;
          corrio = true;
          obs.disconnect();
          var t0 = null;
          var dur = 1800;
          function paso(t) {
            if (t0 === null) t0 = t;
            var p = Math.min((t - t0) / dur, 1);
            var v = min + (meta - min) * (1 - Math.pow(1 - p, 3));
            rango.value = v;
            pintar(Math.round(v));
            if (p < 1) requestAnimationFrame(paso);
          }
          rango.value = min;
          pintar(min);
          requestAnimationFrame(paso);
          setTimeout(function () { if (Math.round(parseFloat(rango.value)) < meta && !caja.hasAttribute("data-tocado")) { rango.value = meta; pintar(meta); } }, dur + 400);
        });
      }, { threshold: 0.7 });
      obs.observe(caja);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
